import {createAsyncThunk} from '@reduxjs/toolkit'

import {SHOPPING_CART, SHOPPING_CART_M} from '@web/core/urls'
import {changeBrowserLocation, openNewTab} from '@web/helpers/browser'
import {isPC} from '@web/helpers/userAgent'

import {NavigationResult, NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

/** 장바구니로 이동 */
const navigateToShoppingCart = createAsyncThunk<NavigationResult, NavigationTypeSelectableParam | void, ThunkApi>(
    'navigateTo/shoppingCart',
    async (args) => {
        const {forceLocationChange = false} = args ?? {}
        const url = isPC ? SHOPPING_CART : SHOPPING_CART_M

        if (forceLocationChange) {
            changeBrowserLocation({
                url,
                type: 'PUSH',
            })
            // page 이동은 그 자체로 추가동작 없이 resolve 된다
            return Promise.resolve()
        }

        openNewTab({url})
    },
)

export default navigateToShoppingCart
